import * as React from "react";
import { DangerousHtml } from "./DangerousHtml";

export const InlineSvg = ({ html, ...props }) => (
  <DangerousHtml html={html} data-comment="InlineSvg" {...props} />
);
